module.exports = __webpack_public_path__ + "img/truckers.eb852497.png";